export const NamesOfParentRoutes = {
  AUTH: "/auth",
  PROCEDURES: "/procedures",
};

// Can't be referenced as `NameOfChildRoutes.ADMIN.ROOT` inside the object literal below, since that
// literal is still being constructed — pulled out to a module-level const instead.
const ADMIN_ROOT = "/admin";

export const NameOfChildRoutes = {
  AUTH: {
    ROOT: "/auth",
    LOGIN: "/login",
  },
  PROJECTS: {
    ROOT: "/projects",
    LIST: "/",
  },
  USERS: {
    ROOT: "/users",
    LIST: "/",
    VIEW: "/:id",
  },
  PROCEDURES: {
    ROOT: "/procedures",
    PROCESSES: "/processes",
    PROCESS: "/processes/:process_id",
    LIST: "/",
    DETAILS: "/:id",
    ONBOARDING: "/onboarding",
    MANAGE: "/manage",
  },
  SURVEYS: {
    ROOT: "/surveys",
    LIST: "/",
    DETAILS: "/:id",
  },
  GOALS: {
    ROOT: "/goals",
    LIST: "/",
  },
  RECOGNITIONS: {
    ROOT: "/recognitions",
    LIST: "/",
    // all-recognitions-screen-plan.md: the dedicated "Your recognitions" screen (See-all PR1) was the
    // first of this reserved surface to actually mount as a `useRoutes` entry
    // (RecognitionContainer.tsx) — reached from the Overview's "See all" link
    // (RecognitionListHeader.tsx), with a back arrow/breadcrumb of its own rather than a tab.
    ALL: "/all",
    // Reserved surface for the tabs RecognitionsTabBarContainer switches between (Overview, Redeem,
    // Leaderboard, Review, Redemptions, Admin) — the container still selects between THESE via TabBar's
    // "section" search param, not a `useRoutes` entry, so they remain unused-for-now scaffold, not dead
    // code.
    OVERVIEW: "/overview",
    REDEEM: "/redeem",
    LEADERBOARD: "/leaderboard",
    REVIEW: "/review",
    REDEMPTIONS: "/redemptions",
    ADMIN: "/admin",
    // all-badges-screen-plan.md (See-all PR2): the dedicated "Your Badges" screen is the second of this
    // reserved surface to actually mount as a `useRoutes` entry (RecognitionContainer.tsx) — reached
    // from the Overview's Badges block "See all" link (BadgesSection.tsx), the same ALL-above pattern.
    BADGES: "/badges",
  },
  ACCOUNTABILITY_CHART: {
    ROOT: "/accountability-chart",
    VIEW: "/",
  },
  PROCEDURE_ASSISTANT: {
    ROOT: "/procedure-assistant",
    LIST: "/",
    DETAIL: "/:chatUuid",
    // phase-r10c: the sources drawer, a third grid column next to the conversation -- `#source-n`
    // (not part of the path) selects/highlights one row (ChatSourcesPanel).
    SOURCES: "/:chatUuid/sources/:messageUuid",
  },
  ADMIN: {
    ROOT: ADMIN_ROOT,
    EVALUATIONS: "/evaluations",
    PROCEDURE_INDEX: "/procedure-index",
    SETTINGS: "/settings",
    AUDIT_LOG: "/audit-log",
  },
  EVALUATIONS: {
    ROOT: `${ADMIN_ROOT}/evaluations`,
    LIST: "/",
    DETAIL: "/:runUuid",
  },
  SETTINGS: {
    ROOT: `${ADMIN_ROOT}/settings`,
    LIST: "/",
    SECTION: "/:sectionSlug",
  },
  AUDIT_LOG: {
    ROOT: `${ADMIN_ROOT}/audit-log`,
    LIST: "/",
    DETAIL: "/:id",
  },
};
